module.exports = __webpack_public_path__ + "img/img-5-mobile.b6db0954.png";